module.exports = __webpack_public_path__ + "img/9788971849019.f730ff8c.jpg";